import axios from "axios";
 
const axiosInstance = axios.create();
 
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("Product_ID_TOKEN");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
 
export default axiosInstance;